import { env } from 'next-runtime-env';

const UMBRACO_BASE_URL = env('NEXT_PUBLIC_UMBRACO_IMG_BASE_URL');

export const getAbsoluteMediaUrl = (url: string | undefined) => {
  if (!url) {
    return url;
  }

  if (/^https?:\/\//i.test(url)) {
    return url;
  }

  try {
    return new URL(url, UMBRACO_BASE_URL).toString();
  } catch {
    return url;
  }
};
